import FormControl from '@material-ui/core/FormControl';

/** @deprecated  Exporting the FormControl component from the Material UI library. */
export default FormControl;
